module.exports = __webpack_public_path__ + "assets/images/bg_03c80d0b222e44d949f798f3a02e20c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = 179
// module chunks = 0